<template>
  <SelectCustomer />
</template>

<script>
import SelectCustomer from "@/components/point-of-sale/Accounts/SelectCustomer";

export default {
  name: "SelectCustomerView",
  components: {SelectCustomer},
}
</script>

<style lang="scss" scoped>
.page{
  height: 100vh;
  overflow-y: scroll;
}
</style>